module.exports = __webpack_public_path__ + "img/map2.44d3cbb4.png";